export var TYPES = {
  ARROWED: 'arrowed',
  ARROWED_BOX: 'arrowedBox',
  ARROWED_NO_LINE: 'arrowedNoLine',
  TABBED: 'tabbed'
};